import type { MouseEvent } from 'react';
import type { WithIntlProps } from 'react-intl';

import type {
  ContentSwitcherProps,
  ContentSwitcherDataProps,
} from '@xing-com/content-switcher';
import { ContentSwitcher } from '@xing-com/content-switcher';
import { useNavigate } from '@xing-com/crate-core-router';

import { addTrackingParamsToURL } from '../../utils/tracking';

export type BaseContentSwitcherDataProps = ContentSwitcherDataProps & {
  trackingAttributes?: {
    [key: string]: string;
  };
};

export type BaseContentSwitcherProps = Omit<
  WithIntlProps<ContentSwitcherProps>,
  'data'
> & {
  data: Array<BaseContentSwitcherDataProps>;
};

export const BaseContentSwitcher: React.FC<BaseContentSwitcherProps> = ({
  data,
  ...props
}) => {
  const navigate = useNavigate();

  const dataWithTracking = data.map((item) => {
    const { trackingAttributes, ...other } = item;
    const url =
      'to' in other ? other.to : 'href' in other ? other.href : undefined;

    if (!trackingAttributes || !url) {
      return item;
    }

    const handleTracking = (e: MouseEvent) => {
      e.preventDefault();
      const trackingUrl = addTrackingParamsToURL({
        url,
        params: trackingAttributes,
      });

      navigate(trackingUrl);
    };

    return {
      ...other,
      onClick: handleTracking,
    };
  });

  return <ContentSwitcher {...{ ...props, data: dataWithTracking }} />;
};
